import { PageStore } from 'bernie-plugin-mobx';

export enum PageId {
  FLIGHTS_SEARCH_ONE_WAY = 'page.Flight-Search-Oneway,F,20',
  FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND = 'page.Flight-Search-Roundtrip.Out,F,20',
  FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND = 'page.Flight-Search-Roundtrip.In,F,20',
  FLIGHTS_SEARCH_MULTI_LEG_0 = 'page.Flight-Search-MDest.Leg0,F,20',
  FLIGHTS_SEARCH_MULTI_LEG_1 = 'page.Flight-Search-MDest.Leg1,F,20',
  FLIGHTS_SEARCH_MULTI_LEG_2 = 'page.Flight-Search-MDest.Leg2,F,20',
  FLIGHTS_SEARCH_MULTI_LEG_3 = 'page.Flight-Search-MDest.Leg3,F,20',
  FLIGHTS_SEARCH_MULTI_LEG_4 = 'page.Flight-Search-MDest.Leg4,F,20',
  FLIGHT_INFORMATION = 'page.Flight.Ratedetails,F,30',
  FLIGHT_SERVICING = 'page.Flights.Servicing.Checkout,F,40',
  FLIGHT_SERVICING_CONFIRMATION = 'page.Flights.Servicing.Confirmation,F,70',
  FLIGHT_SERVICING_AGENT = 'page.Flight.Servicing.Agent,F,70',

  FH_FLIGHTS_SEARCH_ONE_WAY = 'page.Package.FH.Flight-Search-Oneway,P,20',
  FH_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND = 'page.Package.FH.Flight-Search-Roundtrip.Out,P,20',
  FH_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND = 'page.Package.FH.Flight-Search-Roundtrip.In,P,20',
  FH_FLIGHTS_SEARCH_MULTI_LEG_0 = 'page.Package.FH.Flight-Search-MDest.Leg0,P,20',
  FH_FLIGHTS_SEARCH_MULTI_LEG_1 = 'page.Package.FH.Flight-Search-MDest.Leg1,P,20',
  FH_FLIGHTS_SEARCH_MULTI_LEG_2 = 'page.Package.FH.Flight-Search-MDest.Leg2,P,20',
  FH_FLIGHTS_SEARCH_MULTI_LEG_3 = 'page.Package.FH.Flight-Search-MDest.Leg3,P,20',
  FH_FLIGHTS_SEARCH_MULTI_LEG_4 = 'page.Package.FH.Flight-Search-MDest.Leg4,P,20',

  FHC_FLIGHTS_SEARCH_ONE_WAY = 'page.Package.FHC.Flight-Search-Oneway,P,20',
  FHC_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND = 'page.Package.FHC.Flight-Search-Roundtrip.Out,P,20',
  FHC_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND = 'page.Package.FHC.Flight-Search-Roundtrip.In,P,20',
  FHC_FLIGHTS_SEARCH_MULTI_LEG_0 = 'page.Package.FHC.Flight-Search-MDest.Leg0,P,20',
  FHC_FLIGHTS_SEARCH_MULTI_LEG_1 = 'page.Package.FHC.Flight-Search-MDest.Leg1,P,20',
  FHC_FLIGHTS_SEARCH_MULTI_LEG_2 = 'page.Package.FHC.Flight-Search-MDest.Leg2,P,20',
  FHC_FLIGHTS_SEARCH_MULTI_LEG_3 = 'page.Package.FHC.Flight-Search-MDest.Leg3,P,20',
  FHC_FLIGHTS_SEARCH_MULTI_LEG_4 = 'page.Package.FHC.Flight-Search-MDest.Leg4,P,20',

  FC_FLIGHTS_SEARCH_ONE_WAY = 'page.Package.FC.Flight-Search-Oneway,P,20',
  FC_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND = 'page.Package.FC.Flight-Search-Roundtrip.Out,P,20',
  FC_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND = 'page.Package.FC.Flight-Search-Roundtrip.In,P,20',
  FC_FLIGHTS_SEARCH_MULTI_LEG_0 = 'page.Package.FC.Flight-Search-MDest.Leg0,P,20',
  FC_FLIGHTS_SEARCH_MULTI_LEG_1 = 'page.Package.FC.Flight-Search-MDest.Leg1,P,20',
  FC_FLIGHTS_SEARCH_MULTI_LEG_2 = 'page.Package.FC.Flight-Search-MDest.Leg2,P,20',
  FC_FLIGHTS_SEARCH_MULTI_LEG_3 = 'page.Package.FC.Flight-Search-MDest.Leg3,P,20',
  FC_FLIGHTS_SEARCH_MULTI_LEG_4 = 'page.Package.FC.Flight-Search-MDest.Leg4,P,20',
  FLIGHTS_MERCHANDISHING_CHECKOUT = 'page.trip.fao.checkout,F,40',
  FLIGHTS_MERCHANDISHING_CONFIRMATION = 'page.trip.fao.confirmation,F,40',
  FLIGHTS_MERCHANDISHING = 'page.trip.fao.home,F,40'
}

export const FlightsSearchPageIds: { [key: string]: string } = {
  ONE_WAY_0: PageId.FLIGHTS_SEARCH_ONE_WAY,
  ROUND_TRIP_0: PageId.FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND,
  ROUND_TRIP_1: PageId.FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND,
  MULTI_DESTINATION_0: PageId.FLIGHTS_SEARCH_MULTI_LEG_0,
  MULTI_DESTINATION_1: PageId.FLIGHTS_SEARCH_MULTI_LEG_1,
  MULTI_DESTINATION_2: PageId.FLIGHTS_SEARCH_MULTI_LEG_2,
  MULTI_DESTINATION_3: PageId.FLIGHTS_SEARCH_MULTI_LEG_3,
  MULTI_DESTINATION_4: PageId.FLIGHTS_SEARCH_MULTI_LEG_4,

  FH_ONE_WAY_0: PageId.FH_FLIGHTS_SEARCH_ONE_WAY,
  FH_ROUND_TRIP_0: PageId.FH_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND,
  FH_ROUND_TRIP_1: PageId.FH_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND,
  FH_MULTI_DESTINATION_0: PageId.FH_FLIGHTS_SEARCH_MULTI_LEG_0,
  FH_MULTI_DESTINATION_1: PageId.FH_FLIGHTS_SEARCH_MULTI_LEG_1,
  FH_MULTI_DESTINATION_2: PageId.FH_FLIGHTS_SEARCH_MULTI_LEG_2,
  FH_MULTI_DESTINATION_3: PageId.FH_FLIGHTS_SEARCH_MULTI_LEG_3,
  FH_MULTI_DESTINATION_4: PageId.FH_FLIGHTS_SEARCH_MULTI_LEG_4,

  FHC_ONE_WAY_0: PageId.FHC_FLIGHTS_SEARCH_ONE_WAY,
  FHC_ROUND_TRIP_0: PageId.FHC_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND,
  FHC_ROUND_TRIP_1: PageId.FHC_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND,
  FHC_MULTI_DESTINATION_0: PageId.FHC_FLIGHTS_SEARCH_MULTI_LEG_0,
  FHC_MULTI_DESTINATION_1: PageId.FHC_FLIGHTS_SEARCH_MULTI_LEG_1,
  FHC_MULTI_DESTINATION_2: PageId.FHC_FLIGHTS_SEARCH_MULTI_LEG_2,
  FHC_MULTI_DESTINATION_3: PageId.FHC_FLIGHTS_SEARCH_MULTI_LEG_3,
  FHC_MULTI_DESTINATION_4: PageId.FHC_FLIGHTS_SEARCH_MULTI_LEG_4,

  FC_ONE_WAY_0: PageId.FC_FLIGHTS_SEARCH_ONE_WAY,
  FC_ROUND_TRIP_0: PageId.FC_FLIGHTS_SEARCH_ROUND_TRIP_OUT_BOUND,
  FC_ROUND_TRIP_1: PageId.FC_FLIGHTS_SEARCH_ROUND_TRIP_IN_BOUND,
  FC_MULTI_DESTINATION_0: PageId.FC_FLIGHTS_SEARCH_MULTI_LEG_0,
  FC_MULTI_DESTINATION_1: PageId.FC_FLIGHTS_SEARCH_MULTI_LEG_1,
  FC_MULTI_DESTINATION_2: PageId.FC_FLIGHTS_SEARCH_MULTI_LEG_2,
  FC_MULTI_DESTINATION_3: PageId.FC_FLIGHTS_SEARCH_MULTI_LEG_3,
  FC_MULTI_DESTINATION_4: PageId.FC_FLIGHTS_SEARCH_MULTI_LEG_4
};

export const getFlightsSearchPageKey = (pageId: string): number => {
  const strippedPageIdToKey = {
    'Flight-Search-Oneway': 0,
    'Flight-Search-Roundtrip.Out': 0,
    'Flight-Search-Roundtrip.In': 1,
    'Flight-Search-MDest.Leg0': 0,
    'Flight-Search-MDest.Leg1': 1,
    'Flight-Search-MDest.Leg2': 2,
    'Flight-Search-MDest.Leg3': 3,
    'Flight-Search-MDest.Leg4': 4
  };
  const strippedPageId = pageId.substring(pageId.indexOf('Flight-Search'), pageId.indexOf(','));

  return strippedPageIdToKey[strippedPageId];
};

export const isFlightServicingAgent = (page: PageStore) => page.pageId === PageId.FLIGHT_SERVICING_AGENT;
export const isFlightInformation = (page: PageStore) => page.pageId === PageId.FLIGHT_INFORMATION;
export const isFlightsSearch = (page: PageStore) => !isFlightInformation(page) && !isFlightServicingAgent(page);
export const isFlightsServicing = (page: PageStore) => page.pageId === PageId.FLIGHT_SERVICING;
export const isFlightsServicingConfirmation = (page: PageStore) => page.pageId === PageId.FLIGHT_SERVICING_CONFIRMATION;
export const getPageName = (pageId?: string) => pageId?.substring(0, pageId.indexOf(','));
